import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPlus, FiMinus } = FiIcons;

const faqs = [
  {
    q: "What is EPF?",
    a: "EPF (Employees Provident Fund) is a compulsory retirement savings scheme in Malaysia. Both employees and employers contribute monthly to ensure workers have financial security in their old age."
  },
  {
    q: "Is this calculator accurate?",
    a: "Our tool provides high-fidelity estimates based on standard 11% (employee) and 13% (employer) rates. It includes compound interest logic but actual values will vary based on your specific contribution history and actual EPF dividend rates."
  },
  {
    q: "Do I need to create an account?",
    a: "No. MyEPF is designed for speed and privacy. You can use all core features instantly without sharing any personal identification or creating an account."
  },
  {
    q: "Is this an official government website?",
    a: "No. MyEPF is an independent financial tool built by professionals. We are not affiliated with KWSP (Kumpulan Wang Simpanan Pekerja) or any government agency."
  }
];

const FAQItem = ({ q, a }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="border-b border-slate-100 last:border-0">
      <button 
        className="w-full py-6 flex items-center justify-between text-left group"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-lg font-bold text-slate-900 group-hover:text-brand-600 transition-colors">{q}</span>
        <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all ${isOpen ? 'bg-brand-600 text-white rotate-180' : 'bg-slate-50 text-slate-400'}`}>
          <SafeIcon icon={isOpen ? FiMinus : FiPlus} className="w-4 h-4" />
        </div>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="overflow-hidden"
          >
            <p className="pb-6 text-slate-500 leading-relaxed max-w-3xl">
              {a}
            </p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQ = () => {
  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-extrabold text-slate-900">Frequently Asked Questions</h2>
        </div>
        <div className="bg-slate-50/50 rounded-[2.5rem] p-8 md:p-12 border border-slate-100">
          {faqs.map((faq, index) => (
            <FAQItem key={index} {...faq} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;